<template>
  <div class="bg-light min-vh-100 d-flex flex-row align-items-center">
    <CContainer>
      <CRow class="justify-content-center">
        <CCol :md="5">
          <CCardGroup>
            <CCard class="p-4">
              <CCardBody>
                <!-- Top bar: Back button (left) and Language switcher (right) -->
                <div class="d-flex justify-content-between align-items-center mb-3">
                  <div>
                    <CButton
                      v-if="request_id != null && action === null && login_with_password === false"
                      color="secondary"
                      variant="ghost"
                      class="back-btn"
                      @click="backToSendOTP"
                    >
                      <CIcon icon="cil-arrow-left" class="me-2" />
                      {{ $t('pages.login.back') }}
                    </CButton>
                  </div>
                  <div>
                    <LanguageSwitcher />
                  </div>
                </div>

                <CForm v-if="metadata.access_token == null || action === '2fa' || action === 'totp'" @submit.prevent="">
                  <h1>{{ $t('pages.login.title') }}</h1>
                  <p class="text-medium-emphasis">{{ $t('pages.login.signIn') }}</p>

                  <CInputGroup v-if="request_id == null && login_with_password == false" class="mb-3">
                    <CInputGroupText>
                      <CIcon icon="cil-user"/>
                    </CInputGroupText>
                    <CFormInput
                      :placeholder="$t('pages.login.phoneOrEmail')"
                      autocomplete="contact"
                      v-model="contact"
                      @keyup.enter="sendOTP"
                      autofocus
                    />
                  </CInputGroup>

                  <div v-else-if="login_with_password == true && action === null">
                    <CInputGroup class="mb-3">
                      <CInputGroupText>
                        <CIcon icon="cil-user"/>
                      </CInputGroupText>
                      <CFormInput
                        :placeholder="$t('pages.login.phoneEmailUsername')"
                        autocomplete="contact"
                        v-model="contact"
                        autofocus
                      />
                    </CInputGroup>

                    <CInputGroup class="mb-3">
                      <CInputGroupText>
                        <CIcon icon="cil-fingerprint"/>
                      </CInputGroupText>
                      <CFormInput
                        :placeholder="$t('pages.login.password')"
                        autocomplete="password"
                        v-model="password"
                        :type="showPassword ? 'text' : 'password'"
                        @keyup.enter="Login"
                        autofocus
                      />
                      <CButton
                        type="button"
                        color="secondary"
                        variant="outline"
                        @click="showPassword = !showPassword"
                        style="border-top-left-radius: 0; border-bottom-left-radius: 0;"
                        tabindex="-1"
                        class="password-toggle-btn"
                      >
                        <span class="password-toggle-icon">
                          {{ showPassword ? 'Hide' : 'Show' }}
                        </span>
                      </CButton>
                    </CInputGroup>
                  </div>

                  <CInputGroup v-else-if="action === '2fa'" class="mb-3">
                    <CInputGroupText>
                      <CIcon icon="cil-user"/>
                    </CInputGroupText>
                    <CFormInput
                      v-if="is_recover_2fa===false"
                      :placeholder="$t('pages.login.password')"
                      autocomplete="Password"
                      type="password"
                      v-model="two_factor_password"
                      @keyup.enter="adminVerify2fa"
                    />
                    <CFormInput
                      v-if="is_recover_2fa===true"
                      :placeholder="$t('pages.login.code')"
                      autocomplete="Code"
                      type="text"
                      v-model="two_factor_recover_code"
                      @keyup.enter="adminRecover2fa"
                    />
                  </CInputGroup>

                  <CInputGroup v-else-if="action === 'totp'" class="mb-3">
                    <CInputGroupText>
                      <CIcon icon="cil-user"/>
                    </CInputGroupText>
                    <CFormInput
                      v-if="is_recover_totp===false"
                      :placeholder="$t('pages.login.code')"
                      autocomplete="Code"
                      type="password"
                      v-model="totp_code"
                      @keyup.enter="adminVerifyTotp"
                    />
                    <CFormInput
                      v-if="is_recover_totp===true"
                      :placeholder="$t('pages.login.recoveryCode')"
                      autocomplete="Recovery code"
                      type="password"
                      v-model="recovery_code"
                      @keyup.enter="adminRecoverTotp"
                    />
                  </CInputGroup>

                  <CInputGroup v-else class="mb-3">
                    <CInputGroupText>
                      <CIcon icon="cil-user"/>
                    </CInputGroupText>
                    <CFormInput
                      :placeholder="$t('pages.login.code')"
                      autocomplete="code"
                      v-model="code"
                      @keyup.enter="verifyOTP"
                    />
                  </CInputGroup>

                  <CRow class="justify-content-center">

                    <CCol v-if="request_id == null && action === null" :md="12">
                      <div class="d-flex flex-column flex-xl-row gap-2">
                        <CButton v-if="request_id == null && login_with_password == false" color="primary" class="mb-2 mb-xl-0 btn-single-line" @click="sendOTP">{{ $t('pages.login.sendOTP') }}</CButton>
                        <CButton v-if="request_id == null && login_with_password == true" color="primary" class="mb-2 mb-xl-0 btn-single-line" @click="toggleBtn">{{ $t('pages.login.sendOTP') }}</CButton>
                        <CButton v-if="request_id == null || login_with_password == true" color="primary" class="btn-single-line" @click="Login">{{ $t('pages.login.loginWithPassword') }}</CButton>
                      </div>
                    </CCol>

                    <CCol v-else-if="action === '2fa'" :md="12">
                      <div class="d-flex flex-column flex-xl-row gap-2">
                        <CButton v-if="is_recover_2fa === false" color="primary" class="mb-2 mb-xl-0 btn-single-line" @click="adminVerify2fa"> {{ $t('pages.login.verify2fa') }}</CButton>
                        <CButton v-if="is_recover_2fa === false" color="primary" class="mb-2 mb-xl-0 btn-single-line" @click="adminRecover2fa"> {{ $t('pages.login.recover2fa') }}</CButton>
                        <CButton v-if="is_recover_2fa === true" color="primary" class="btn-single-line" @click="adminRecover2fa"> {{ $t('pages.login.recover2fa') }}</CButton>
                      </div>
                    </CCol>

                    <CCol v-else-if="action === 'totp'" :md="12">
                      <div class="d-flex flex-column flex-xl-row gap-2">
                        <CButton v-if="is_recover_totp === false" color="primary" class="mb-2 mb-xl-0 btn-single-line" @click="adminVerifyTotp"> {{ $t('pages.login.verifyTOTP') }}</CButton>
                        <CButton v-if="is_recover_totp === false" color="primary" class="mb-2 mb-xl-0 btn-single-line" @click="is_recover_totp = true"> {{ $t('pages.login.recoverTOTP') }}</CButton>
                        <CButton v-if="is_recover_totp === true" color="primary" class="btn-single-line" @click="adminRecoverTotp"> {{ $t('pages.login.recoverTOTP') }}</CButton>
                      </div>
                    </CCol>

                    <CCol v-else :md="12">
                      <div class="d-flex gap-2">
                        <CButton color="primary" class="px-4 btn-single-line" @click="verifyOTP"> {{ $t('pages.login.verifyOTP') }}</CButton>
                      </div>
                    </CCol>

                  </CRow>
                </CForm>
                <CForm v-else-if="action === null">
                  <h1>{{ $t('pages.login.youAreLoggedIn') }}</h1>
                  <CRow>
                    <CCol :md="6">
                      <CButton color="primary" class="px-4" @click="logOut"> {{ $t('pages.login.logOut') }}</CButton>
                    </CCol>
                    <CCol :md="6">
                      <router-link to="/logs">
                        <CButton color="success" class="px-4"> {{ $t('pages.login.logs') }}</CButton>
                      </router-link>
                    </CCol>
                  </CRow>
                </CForm>
              </CCardBody>
            </CCard>
          </CCardGroup>
        </CCol>
      </CRow>
    </CContainer>
  </div>
</template>

<script>
import store from '@/store/index'
import LanguageSwitcher from '@/components/LanguageSwitcher.vue'

const {AccountServiceClient} = require('@/common/api/services/account/account_grpc_web_pb')
const common_pb = require('@/common/api/services/common/common_pb')
const account_pb = require('@/common/api/services/account/account_pb')
const {getBaseUrl} = require('@/common/utils');

export default {
  name: 'Login',
  components: {
    LanguageSwitcher
  },
  data() {
    return {
      accountService: new AccountServiceClient(getBaseUrl("account"), null, null),
      metadata: {
        'network_id': store.state.network_id || process.env.VUE_APP_NETWORK_ID,
      },
      contact: null,
      request_id: null,
      password: null,
      network: null,
      limit: null,
      login_with_password: false,
      code: null,
      is_recover_2fa: false,
      is_recover_totp: false,
      two_factor_recover_code: "",
      two_factor_password: null,
      recovery_code: null,
      totp_code: null,
      action: null,
      showPassword: false,
    }
  },
  mounted() {

    if (store.state.access_token) {
      this.metadata.access_token = store.state.access_token
    }
  },
  methods: {
    async toggleBtn() {
      this.login_with_password = false
    },
    async fixPhone() {
      // Remove any non-digit characters
      let phone = this.contact.replace(/\D/g, '');
      let defaultCountryCode = '98'

      // Check if the phone starts with "00" or "+" (international format)
      if (phone.startsWith('00')) {
          phone = phone.substring(2); // Remove the "00"
      } else if (phone.startsWith('98') || phone.startsWith('+98')) {
          phone = phone.replace(/^(\+|980|98)/, '98'); // Handle Iranian numbers
      } else if (phone.startsWith('+')) {
          phone = phone.substring(1); // Remove the "+"
      } else if (phone.startsWith('0')) {
          // Local Iranian numbers starting with "0"
          phone = defaultCountryCode + phone.substring(1); // Replace "0" with country code
      } else {
          // Assume local number without "0"
          phone = defaultCountryCode + phone;
      }

      this.contact = phone;
    },
    async Login() {
      if (!this.login_with_password) {
        this.login_with_password = true
      }

      if (this.contact && this.password) {
        const request = new account_pb.LoginRequest()
        request.setLogin(this.contact)
        request.setPassword(this.password)
        try {
          const response = await this.$grpcService.sendRequest('account', 'adminLogin', request, this.metadata)
          this.metadata.access_token = response.token.accessToken
          if (response.action === '2fa') {
            this.action = '2fa';
          }
          else if (response.action === 'totp') {
            this.action = 'totp';
          } else {
            store.commit('setAccessToken', response.token.accessToken)
            store.commit('setUser', response.account)
            await this.getAllNetworks()
          }
        } catch (err) {
          this.$toast.add({severity: 'error', summary: err.summary, detail: err.detail, life: 6000})
        }
      }
    },
    async sendOTP() {
      const request = new account_pb.SendOtpRequest()

      if (this.contact.includes('@')) {
        request.setEmail(this.contact)
      } else {
        this.fixPhone()
        request.setPhone(this.contact)
      }

      try {
        const response = await this.$grpcService.sendRequest('account', 'adminSendOTP', request, this.metadata)
        this.request_id = response.requestId
        this.limit = response.limit
      } catch (err) {
        this.$toast.add({severity: 'error', summary: err.summary, detail: err.detail, life: 6000})
      }

    },
    async verifyOTP() {
      const request = new account_pb.VerifyOtpRequest()
      request.setRequestId(this.request_id)
      request.setPassword(this.code)
      try {
        const response = await this.$grpcService.sendRequest('account', 'adminVerifyOTP', request, this.metadata)
        this.metadata.access_token = response.token.accessToken
        if (response.action === '2fa') {
          this.action = '2fa';
        }
        else if (response.action === 'totp') {
          this.action = 'totp';
        } else {
          store.commit('setAccessToken', response.token.accessToken)
          store.commit('setUser', response.account)
          await this.getAllNetworks()
        }
      } catch (err) {
        this.$toast.add({severity: 'error', summary: err.summary, detail: err.detail, life: 6000})
      }

    },
    async adminVerify2fa() {
      const request = new account_pb.Verify2faRequest()
      request.setPassword(this.two_factor_password)
      try {
        const response = await this.$grpcService.sendRequest('account', 'adminVerify2fa', request, this.metadata)
        this.metadata.access_token = response.token.accessToken
        store.commit('setAccessToken', response.token.accessToken)
        store.commit('setUser', response.account)
        await this.getAllNetworks()
      } catch (err) {
        this.$toast.add({severity: 'error', summary: err.summary, detail: err.detail, life: 6000})
      }
    },
    async adminVerifyTotp() {
      const request = new account_pb.TotpCodeRequest()
      request.setCode(this.totp_code)
      try {
        const response = await this.$grpcService.sendRequest('account', 'adminVerifyTotp', request, this.metadata)
        this.metadata.access_token = response.token.accessToken
        store.commit('setAccessToken', response.token.accessToken)
        store.commit('setUser', response.account)
        await this.getAllNetworks()
      } catch (err) {
        this.$toast.add({severity: 'error', summary: err.summary, detail: err.detail, life: 6000})
      }
    },
    async adminRecoverTotp() {
      const request = new account_pb.TotpRecoveryCodeRequest()
      request.setRecoveryCode(this.recovery_code)
      try {
        await this.$grpcService.sendRequest('account', 'adminRecoverTotp', request, this.metadata)
        store.commit('setAccessToken', null);
        window.location.reload();
        this.$toast.add({severity: 'success', summary: 'Success', detail: "Login again", life: 6000})
      } catch (err) {
        this.$toast.add({severity: 'error', summary: err.summary, detail: err.detail, life: 6000})
      }
    },
    async adminRecover2fa() {
      this.is_recover_2fa=true;
      const request = new account_pb.Recover2faRequest()
      request.setCode(this.two_factor_recover_code)
      try {
        const response = await this.$grpcService.sendRequest('account', 'adminRecover2fa', request, this.metadata)
        if (response.contact) {
          this.$toast.add({severity: 'success', summary: 'Code sent', detail: response.contact, life: 6000})
        }
        else {
          store.commit('setAccessToken', null);
          window.location.reload();
          this.$toast.add({severity: 'success', summary: 'Success', detail: "Login again", life: 6000})
        }
      } catch (err) {
        this.$toast.add({severity: 'error', summary: err.summary, detail: err.detail, life: 6000})
      }
    },
    async select_network_id(networks) {
      return networks.find(item => item.organization.id !== "" && item.organization.title !== "all");
    },
    async getAllNetworks() {
      const request = new common_pb.Pagination()
      request.setLimit(1)
      try {
        const response = await this.$grpcService.sendRequest('account', 'adminGetAllNetworks', request, this.metadata)
        let res = response.itemsList
        let network = await this.select_network_id(res)
        store.commit('setAllNetworks', res.filter(item => item.organization.title.toLowerCase() !== "all").map(({ token, organization }) => ({ token, organization })))
        this.metadata.access_token = network.token.accessToken
        store.commit('setAccessToken', network.token.accessToken)
        store.commit('setRefreshToken', network.token.refreshToken)
        this.$router.push('/logs');
      } catch (err) {
        this.$toast.add({severity: 'error', summary: err.summary, detail: err.detail, life: 6000})
      }
    },
    async changeNetwork(token, network) {
      try {
        this.metadata.access_token = token.accessToken
        store.commit('setAccessToken', token.accessToken);
        store.commit('setRefreshToken', token.refreshToken);
        store.commit('setNetworkId', network);
        this.metadata.network_id = network
        window.location.reload();
      } catch (err) {
        this.$toast.add({severity: 'error', summary: err.summary, detail: err.detail, life: 6000})
      }
    },
    async logOut() {
      const request = new common_pb.Empty()
      try {
        await this.$grpcService.sendRequest('account', 'logOut', request, this.metadata)
      } catch (err) {
        this.$toast.add({severity: 'error', summary: err.summary, detail: err.detail, life: 6000})
      }
      this.metadata.request_id = null
      delete this.metadata.access_token
      store.commit('setAccessToken', null)
      store.commit('setRefreshToken', null)
      store.commit('setNetworkId', null)
      store.commit('setAllNetworks', null)
      store.commit('setUser', null)
      store.commit('setTotpSecret', null)
       this.$router.push('/pages/login');
    },
    backToSendOTP() {
      this.request_id = null;
      this.code = null;
      this.limit = null;
    },
  },
}
</script>

<style scoped>
.btn-single-line {
  white-space: nowrap;
  font-size: 0.95rem;
  padding-left: 1.25rem !important;
  padding-right: 1.25rem !important;
  min-width: 140px;
}

/* Update responsive styles for <= 1200px */
@media (max-width: 1199.98px) {
  .btn-single-line {
    min-width: 100%;
    width: 100%;
    margin-right: 0 !important;
    font-size: 1rem;
    padding: 0.5rem 1rem !important;
  }
  
  .d-flex.flex-column.flex-xl-row {
    width: 100%;
  }

  .ms-1 {
    margin-left: 0 !important;
  }
}

/* Custom style for password toggle icon/button */
.password-toggle-btn {
  padding: 0 0.75rem;
  display: flex;
  align-items: center;
  border-left: none !important;
  background: #f8f9fa;
  transition: background 0.2s;
}
.password-toggle-btn:hover {
  background: #e2e6ea;
}
.password-toggle-icon {
  font-size: 1.05rem;
  color: #6c757d;
  font-weight: 500;
  letter-spacing: 0.02em;
}

/* Responsive fix for mobile view */
@media (max-width: 575.98px) {
  .btn-single-line {
    min-width: 100%;
    width: 100%;
    margin-right: 0 !important;
    font-size: 1rem;
    padding: 0.5rem 1rem !important;
  }
  
  .d-flex.flex-column.flex-sm-row {
    width: 100%;
  }
}

.back-btn {
  padding-left: 0.75rem;
  padding-right: 1.25rem;
  font-size: 1rem;
  background: transparent;
  border: none;
  box-shadow: none;
  color: #6c757d;
  display: flex;
  align-items: center;
}
.back-btn:hover {
  color: #495057;
  background: #f1f3f5;
}
</style>
